// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oJxTh","title":"styles_title__9oTeH","header":"styles_header__2Pll1","back":"styles_back__8A9ts","content":"styles_content__W0bu0"};